/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccountState } from '../models/AccountState';

export class GcpOrganization {
  /**
  * Eon-assigned account ID.
  */
  'id': string;
  /**
  * The organization display name in Eon.
  */
  'name': string;
  /**
  * GCP Organization ID.
  */
  'organizationId': string;
  /**
  * GCP Organization folder ID.
  */
  'folderId'?: string;
  /**
  * GCP Organization management project ID.
  */
  'managementProjectId': string;
  /**
  * GCP Organization management service account ID.
  */
  'managementServiceAccountId': string;
  'state': AccountState;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "organizationId",
      "baseName": "organizationId",
      "type": "string",
      "format": ""
    },
    {
      "name": "folderId",
      "baseName": "folderId",
      "type": "string",
      "format": ""
    },
    {
      "name": "managementProjectId",
      "baseName": "managementProjectId",
      "type": "string",
      "format": ""
    },
    {
      "name": "managementServiceAccountId",
      "baseName": "managementServiceAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "state",
      "baseName": "state",
      "type": "AccountState",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpOrganization.attributeTypeMap;
  }

  public constructor() {
  }
}



